import { useEffect, useState } from "react";
import { API } from "../api/api";
import type { Session } from "../api/types";

export default function Overview() {
  const [tenant] = useState<any>(null);
  const [stats] = useState<any>(null);
  const [sessions, setSessions] = useState<Session[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        // 1) tenant
        // const me = await API.get("/tenants/me");
        // setTenant(me.data.tenant);

        // // 2) stats
        // const s = await API.get("/stats/overview");
        // setStats(s.data);

        // 3) sessions
        const ses = await API.get("/api/sessions");

        // 👇 ALWAYS wrap single session into an array
        setSessions([ses.data]);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, []);

  if (loading) return <div>Loading...</div>;

  return (
    <div>
      <h2>Overview</h2>

      {/* Tenant */}
      <h3>Tenant</h3>
      {tenant ? (
        <div>
          <div><strong>ID:</strong> {tenant.id}</div>
          <div><strong>Name:</strong> {tenant.displayName}</div>
          <div><strong>Created:</strong> {tenant.createdAt}</div>
        </div>
      ) : (
        <div>No tenant (new user onboarding pending)</div>
      )}

      {/* Stats */}
      <h3 style={{ marginTop: "1.5rem" }}>Statistics</h3>
      <ul>
        <li><strong>Clients:</strong> {stats?.clients ?? 0}</li>
        <li><strong>Users:</strong> {stats?.users ?? 0}</li>
        <li><strong>Active Sessions:</strong> {sessions.length}</li>
      </ul>

      {/* Sessions */}
      <h3 style={{ marginTop: "2rem" }}>Active Sessions</h3>

      {sessions.length > 0 ? (
        <table border={1} cellPadding={6} style={{ marginTop: 12 }}>
          <thead>
            <tr>
              <th>Session</th>
              <th>Client</th>
              <th>Platform</th>
              <th>Device</th>
              <th>IP</th>
              <th>Created</th>
              <th>Last Active</th>
            </tr>
          </thead>

          <tbody>
            {sessions.map((s) => (
              <tr key={s.session_id}>
                <td>{s.session_id}</td>
                <td>{s.client_id}</td>
                <td>{s.platform}</td>
                <td>{s.device_id}</td>
                <td>{s.ip_address}</td>
                <td>{new Date(s.created_at).toLocaleString()}</td>
                <td>{new Date(s.last_active_at).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p>No active sessions</p>
      )}
    </div>
  );
}